module.exports = __webpack_public_path__ + "static/media/unizin-logo.81b430e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/unizin-logo.svg
// module id = 440
// module chunks = 0